/**
 * 내가 옮긴 문장을 표 파일(CSV)로 내보낸다.
 *
 * 책 내보내기(booksCsv.js)와 같은 규칙이다 — 엑셀이 한글을 깨뜨리지 않게
 * 맨 앞에 BOM, 줄 끝은 CRLF. 둘 중 하나만 빠져도 윈도우 엑셀에서 글자가
 * 깨지거나 한 줄로 붙는다.
 *
 * 문장은 줄바꿈을 품은 채로 저장된다. 칸을 따옴표로 감싸면 엑셀이 한 칸
 * 안의 여러 줄로 제대로 읽는다(cell 이 그 일을 한다).
 */

/** 큰따옴표·쉼표·줄바꿈이 든 칸은 감싸고, 안의 따옴표는 두 번 쓴다 */
const cell = (v) => {
  const s = v == null ? "" : String(v);
  return /["\n\r,]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

const COLUMNS = ["문장", "책", "저자", "쪽", "공개", "남긴 날", "좋아요"];

/** 한국 날짜로. 서버는 UTC 로 주는데, 밤에 적은 문장이 하루 전으로 보이면 안 된다. */
export const kstDay = (iso) => {
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return "";
  return new Date(t + 9 * 3600000).toISOString().slice(0, 10).replace(/-/g, ".");
};

export function quotesToCsv(quotes) {
  /* 최근에 옮긴 문장이 위로. 같은 날이면 책 제목 순으로 둬서 여러 번 받아도
     순서가 바뀌지 않는다. */
  const sorted = [...(quotes || [])].sort((x, y) => {
    const a = String(x.createdAt ?? ""), b = String(y.createdAt ?? "");
    if (a !== b) return b.localeCompare(a);
    return String(x.bookTitle ?? "").localeCompare(String(y.bookTitle ?? ""), "ko");
  });
  const rows = sorted.map((q) => [
    q.text,
    q.bookTitle,
    q.bookAuthor,
    q.page ?? "",
    q.isPublic ? "공개" : "나만 보기",
    kstDay(q.createdAt),
    (q.likes ?? []).length || "",
  ].map(cell).join(","));
  return "﻿" + [COLUMNS.join(","), ...rows].join("\r\n") + "\r\n";
}

/** 오늘 날짜를 붙인 파일 이름 — 여러 번 받아도 서로 덮어쓰지 않게 */
export function quotesCsvFileName(today = new Date()) {
  const kst = new Date(today.getTime() + 9 * 3600000).toISOString().slice(0, 10);
  return `muroo-quotes-${kst}.csv`;
}
